function WarningPopup({ open, countdown, onConfirm }) {
  if (!open) return null
  return (
    <div
      style={{
        display: 'block',
        position: 'fixed',
        top: '20px',
        right: '20px',
        height: '130px',
        width: '300px',
        backgroundColor: 'orange',
        color: 'white',
        padding: '10px',
        borderRadius: '5px',
        zIndex: 1000
      }}
    >
      <p>
        You've been idle for a while. You will be logged out in {countdown} seconds if no action is
        taken.
      </p>
      <button
        onClick={onConfirm}
        style={{
          color: 'black',
          backgroundColor: 'white',
          padding: '5px 10px',
          marginTop: '10px',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer'
        }}
      >
        Confirm
      </button>
    </div>
  )
}

export default WarningPopup
